export default "__VITE_ASSET__DoPFQCAW__"